import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { buildMortgageBannerUnderPriceIpotekaUrl } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

import { EntryPointRow } from '../EntryPointRow';
import icon from './assets/discount.svg';
import { TMortgageBannerVerticalName, trackMortgageWidgetAnchorClick, trackMortgageWidgetAnchorShow } from './tracking';

interface IMortgageWidgetPromoDiscountProps {
  mortgagePromoDesign: string | null;
  verticalName: TMortgageBannerVerticalName;
}

export const MortgageWidgetPromoDiscount: React.FC<IMortgageWidgetPromoDiscountProps> = ({ verticalName }) => {
  const redirectPath = buildMortgageBannerUnderPriceIpotekaUrl(verticalName);

  const handleAnchorClick = () => {
    trackMortgageWidgetAnchorClick(verticalName);
  };

  return (
    <ActionAfterViewObserver callback={() => trackMortgageWidgetAnchorShow(verticalName)} callbackDelay={1000}>
      <EntryPointRow dark onClick={handleAnchorClick} imgSrc={icon} title="Ипотека" link={redirectPath} />
    </ActionAfterViewObserver>
  );
};
